import { useAppSelector } from '../../../../store/hooks'
import { useActions } from '../../../../store/use-actions'
import { actions as rawActions } from '../../state/strategy-slice'
import { LeverageEditorDumb } from './dumb'

export const LeverageEditor = () => {
  const state = useAppSelector(state => state.strategy.selectedStrategy.leverage)
  const commonState = useAppSelector(state => state.strategy)
  const actions = useActions(rawActions)

  return (
    <LeverageEditorDumb
      assets={commonState.protectionAssets}
      errors={commonState.errors}
      isGeneratingCharts={
        commonState.isGeneratingPerformanceChart || commonState.isGeneratingProjectionChart
      }
      setType={type => actions.setLeverageType(type)}
      state={state}
      onChangeConstantProportionLeverageRatio={value =>
        actions.setLeverageConstantProportionLeverageRatio(value)
      }
      onChangeTargetVolatility={value => actions.setLeverageTargetVolatility(value)}
      onChangeVolControlLeverageRatio={value => actions.setLeverageVolControlLeverageRatio(value)}
      onInspectAsset={assetId => actions.inspectAsset(assetId)}
      onSelectAsset={asset => actions.setLeverageVolControlProtectionAsset(asset)}
    />
  )
}
